<script>
import ChatVisaic from '@/league/components/Chats/ChatVisaic.vue';
import MinitChat from '@/league/components/Chats/MinitChat.vue';

export default {
  name: 'ChatController',
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  CHATS: {
    visaic: ChatVisaic,
    minnit: MinitChat,
  },
  data() {
    return {
      chatComponent: null,
    };
  },
  methods: {
    getChat() {
      const alias = this.event?.chat?.chatAlias;
      this.chatComponent = this.$options.CHATS[alias] || this.$options.CHATS.visaic;
    },
  },
  mounted() {
    this.getChat();
  },
};
</script>

<template>
    <component
      v-if='chatComponent'
      :is="chatComponent"
      :event="event"
    />
</template>
